import { speakOutLoudRichtext, stopSpeechToText } from "../../services/functions"
import { useAccessibility } from "../../context/AccessibilityContext"

type BaseSubheadlineType = {
    label?: string
    customColor?: string
    classProps?: string
}

export default function BaseSubheadline(props: BaseSubheadlineType) {
    const { readText } = useAccessibility()

    return (
        <>
            {props.label && props.label !== undefined && props.label !== null && (
                <h6
                    onMouseLeave={readText ? () => stopSpeechToText() : () => {}}
                    onMouseEnter={readText ? () => speakOutLoudRichtext(props.label) : () => {}}
                    className={`text-lg font-headline font-bold ${props.classProps}`}
                    style={props.customColor ? { color: props.customColor } : {}}>
                    {props.label}
                </h6>
            )}
        </>
    )
}
